const navItems = document.querySelectorAll(".navbar_nav .nav-item");

if (navItems && navItems.length > 0) {
    navItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            navItems.forEach((el) => el.classList.remove("active"));
            item.classList.add("active");
        });
        
        item.addEventListener("mouseleave", () => {
            item.classList.remove("active");
        });
    });
}
document.addEventListener('DOMContentLoaded', function() {
  const searchbarBtn = document.querySelector('.search_bar_icon');
  const menuOpening = document.querySelector('.menu-drawer-container');
  const headIcon = document.querySelector('summary.header__icon--menu');

  if (searchbarBtn && menuOpening && headIcon) {
    const parent = searchbarBtn.parentNode;

    searchbarBtn.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent click from bubbling to document
      parent.classList.toggle('searchbar_active');

      if (parent.classList.contains('searchbar_active')) {
        menuOpening.classList.remove('menu-opening');
        menuOpening.removeAttribute('open');

        const attrs = {
          'aria-label': 'Menu',
          'aria-expanded': 'false',
          'role': 'button',
          'aria-controls': 'menu-drawer'
        };

        for (const [key, value] of Object.entries(attrs)) {
          headIcon.setAttribute(key, value);
        }
      }
    });

    // Prevent clicks inside the parent container from closing the search bar
    parent.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    // Close search bar when clicking outside
    document.addEventListener('click', function() {
      parent.classList.remove('searchbar_active');
    });

    // Close search bar when menu opens
    headIcon.addEventListener('click', function() {
      parent.classList.remove('searchbar_active');
    });
  }
});

// MOBILE SEARCHBAR HIDE/SHOW
document.addEventListener("DOMContentLoaded", function () {

  const searchbarBtn = document.querySelector(".search_bar_icon");
  const searchWrapper = document.querySelector(".header__search");

  if (!searchbarBtn || !searchWrapper) return;

  // Toggle search
  searchbarBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    searchWrapper.classList.toggle("searchbar_active");
  });

  // Prevent closing when clicking inside form
  searchWrapper.addEventListener("click", function (e) {
    e.stopPropagation();
  });

  // Close when clicking outside
  document.addEventListener("click", function () {
    searchWrapper.classList.remove("searchbar_active");
  });

});
// SWIPER JS
 const vsCatSlider = new Swiper('.vs-categories__swiper', {
  slidesPerView: '1.2',
  spaceBetween: 15,
  loop: true,
  speed: 300,
  autoplay: {
    delay: 8000, // 8 seconds
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.vs-categories .swiper-button-next',
    prevEl: '.vs-categories .swiper-button-prev',
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
       spaceBetween: 30,
    },
  },
});
